import React from 'react';
import {TooltipHost, getTheme} from '@fluentui/react';

interface ISubOrganizationBadgeProps {
    /** Display name of the sub-organization, already resolved (falls back to the id upstream). */
    name?: string;
    /** Tooltip text; defaults to a description of the scope. */
    tooltip?: string;
    compact?: boolean;
}

/**
 * Small pill marking something as belonging to one sub-organization (customer) rather than the whole
 * organization: a scoped extension install, a price row from a customer price file.
 */
export const SubOrganizationBadge: React.FC<ISubOrganizationBadgeProps> = (props) => {
    const theme = getTheme();

    if (!props.name) return null;

    const badge = (
        <span
            data-testid='sub-organization-badge'
            style={{
                display: 'inline-block',
                maxWidth: '180px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                padding: props.compact ? '0 6px' : '2px 8px',
                borderRadius: '10px',
                backgroundColor: theme.palette.themeLighter,
                border: `1px solid ${theme.palette.themeTertiary}`,
                color: theme.palette.themeDarker,
                fontSize: props.compact ? '10px' : '12px',
                lineHeight: props.compact ? '16px' : undefined,
            }}
        >
            {props.name}
        </span>
    );

    return <TooltipHost content={props.tooltip ?? `Scoped to ${props.name}`}>{badge}</TooltipHost>;
};

export default SubOrganizationBadge;
